export default "__VITE_ASSET__iSNYgSOT__"